






















































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import SingleRowSelect from '@/components/common/singleRowSelect/SingleRowSelect.vue'
import { getRegions } from '../models/api'

@Component({
  components: { SingleRowSelect }
})
export default class Condition extends Vue {
  @Prop() public msg!: string

  public filterList = []
  public grade = ''
  public rating = ''
  public grade_name = ''
  public section = 0
  public section_name = '全部'
  public year = ''
  public term = ''
  public paper_type = ''
  public paper_type_name
  public city = '' // 市
  public city_name = '' // 市
  public cityArray = [] // 市

  public district = '' // 区
  public district_name = '' // 区
  public districtArray = [] // 区

  public get allRules() {
    return this.$store.state.allRules
  }

  public get getFilters() {
    return this.$store.state.filters
  }
  @Watch('getFilters', { deep: true })
  onFiltersChange(val) {
    // debugger
    console.log('val99', val)
    this.city = val.city
    this.cityArray = val.cityArray
    this.districtArray = val.districtArray
    this.district = val.district
    this.term = val.term
    // this.region_code = val.region_code
    this.grade = val.grade
    this.grade_name = val.grade_name
    // this.region_name = val.region_name
    this.year = val.year
    this.paper_type = val.paper_type
  }

  @Watch('allRules', { immediate: true, deep: true })
  onRulesChange(val: any) {
    this.filterList = val
  }
  @Watch('section')
  onSectionChange(val: any) {
    if (val != 0) {
      this.getRegions(val, 'city')
    } else {
      this.section = 0
      this.section_name = '全部'
    }
    this.city = ''
    this.city_name = ''
    this.cityArray = []
    this.district = ''
    this.district_name = ''
    this.districtArray = []
    this.dispatchData()
  }

  public clickCity(itm) {
    this.city = itm[0]
    this.city_name = itm[1]
    this.getRegions(itm[0], 'district')
    this.dispatchData()
  }

  public clickDistrict(itm) {
    this.district = itm[0]
    this.district_name = itm[1]
    this.dispatchData()
  }
  public judgeSelected(itm, type) {
    if (type == 'city') {
      return itm[0] == this.city
    } else {
      return itm[0] == this.district
    }
  }
  public async getRegions(val, type) {
    if (val !== 0) {
      let obj = {
        pcode: val
      }
      let data = await getRegions(obj)
      if (type == 'city') {
        this.cityArray = data.regions
      } else {
        this.districtArray = data.regions
      }
    }
  }

  // methods
  public getChoose(val: any) {
    switch (val.group) {
      case '年级：':
        this.grade = val.value
        this.grade_name = val.name
        this.rating = val.rating || ''
        this.dispatchData()
        break
      case '地区：':
        this.section = val.value
        this.section_name = val.name
        this.dispatchData()
        break
      case '年份：':
        this.year = val.value
        this.dispatchData()
        break
      case '学期：':
        this.term = val.value
        this.dispatchData()
        break
      case '来源：':
        this.paper_type = val.value
        this.paper_type_name = val.name
        this.dispatchData()
        break
      default:
        break
    }
  }
  /**
   * dispatchData
   */
  public dispatchData() {
    var region_code1
    var region_name1
    if (this.district) {
      region_code1 = this.district
      region_name1 = this.district_name
    } else if (this.city) {
      region_code1 = this.city
      region_name1 = this.city_name
    } else if (this.section || this.section === 0) {
      region_code1 = this.section
      region_name1 = this.section_name
    }

    this.$store.commit('SET_FILTERS', {
      grade: this.grade,
      rating: this.rating,
      grade_name: this.grade_name,
      region_code: region_code1,
      region_name: region_name1,
      year: this.year,
      term: this.term,
      paper_type: this.paper_type,
      paper_type_name: this.paper_type_name,
      city: this.city,
      district: this.district,
      cityArray: this.cityArray,
      districtArray: this.districtArray
    })
  }
}
